<svelte:options customElement={{
  tag: 'textarea-field',
  shadow: 'none',
  props: {
    name: { reflect: true, type: 'String' },
    placeholder: { reflect: true, type: 'String' },
    value: { reflect: true, type: 'String' },
    rows: { reflect: true, type: 'Number' },
    error: { reflect: true, type: 'String' },
    widthClass: { reflect: true, type: 'String', attribute: 'width-class' }
  }
}} />

<script>
  /**
   * textarea：テキストエリア
   * パーツライブラリ準拠の mod-textarea 構造
   */
  export let name = '';
  export let placeholder = 'テキストエリア';
  export let value = '';
  export let rows = 5;
  export let error = '';
  export let widthClass = 'width-u-100 width-sp-100';

  let textareaId = `textarea_${name || Math.random().toString(36).slice(2, 8)}`;
</script>

<div class:__error={!!error}>
  <div class="mod-textarea">
    <label for={textareaId} title={name}>
      <textarea
        id={textareaId}
        {name}
        {placeholder}
        {rows}
        class={widthClass}
        bind:value
        on:input
        on:change
      ></textarea>
    </label>
  </div>
  {#if error}
    <p class="color_red mt10">{error}</p>
  {/if}
</div>
